import _ from 'lodash';
import { LocaleUtils } from '../utils/zeequantConstants';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
export const BUILDER_QUANT_CONFIG_VERSION = '2.17';
export const SPECIAL_CHARACTER_REGEX = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>?~]/;

const isCrypto = LocaleUtils().isCrypto();
const locale = LocaleUtils().locale();
/** @type {{[key:string]:{value:AVAILABLE_ORDER_TYPE, displayName:string, shouldShow:boolean}}} */

export const ORDER_TYPES = {
  paper: { value: 'paper', displayName: 'Paper Testing', shouldShow: false },
  oneClick: { value: 'oneclick', displayName: 'Oneclick Trading', shouldShow: false },
  automatic: { value: 'automatic', displayName: 'Auto Trading', shouldShow: false }
};

export const BFO_INSTRUMENTS = ['SENSEX', 'BANKEX'];

export const RUN_TYPES = { live: 'live', historic: 'historic' };
export const RUN_GRANULARITY = { second: 'second', minute: 'minute' };
export const OPTION_TYPES = { CE: 'CE', PE: 'PE' };
export const TRANSACTION_TYPES = { buy: 'buy', sell: 'sell' };
export const SL_TRAIL_TYPES = { Linear: 'Linear', BookAndLinear: 'BookAndLinear' };

export const SEGMENT_CONFIG = { future: 'future', equity: 'equity', option: 'option' };

export const PRODUCT_TYPES = {
  mis: { label: 'MIS', value: 'mis' },
  normal: { label: 'Normal', value: 'normal' },
};

export const TRADE_TYPES = {
  positional: { label: 'Positional', value: 'positional' },
  intraday: { label: 'Intraday', value: 'intraday' }
}

export const STOPS_VALUE_TYPES = { Percent: 'Percent', Amount: 'Amount', Points: 'Points' };
export const POSITION_VALUE_TYPES = { Lot: 'lot', Amount: 'amount' };

export const INTENT_TYPES = {
  CloseLeg: 'CloseLeg',
  ExecuteLeg: 'ExecuteLeg',
  ExitTransaction: 'ExitTransaction',
  UpdateStopLoss: 'UpdateStopLoss',
  ReEntry: 'ReEntry',
  OpenBasket: 'OpenBasket',
  OpenLeg: 'OpenLeg',
  OpenCase: 'OpenCase',
  CloseCase: 'CloseCase',
};

export const INTENT_CATEGORIES = {
  Open: 'Open',
  Other: 'Other',
  Case: 'Case',
};

export const getIntentCategory = (intentType) => {
  if (intentType === INTENT_TYPES.CloseLeg || intentType === INTENT_TYPES.UpdateStopLoss) {
    return INTENT_CATEGORIES.Other;
  }
  if (intentType === INTENT_TYPES.OpenCase || intentType === INTENT_TYPES.CloseCase) {
    return INTENT_CATEGORIES.Case;
  }
  return INTENT_CATEGORIES.Open;
};

export const QUICK_ADJUSTMENT_TRIGGERS = {
  ExitedInLoss: { value: 'ExitedInLoss', displayName: 'Exited in Loss', shortLabel: 'LossExit' },
  ExitedInProfit: { value: 'ExitedInProfit', displayName: 'Exited in Profit', shortLabel: 'ProfitExit' },
};
export const QUICK_ADJUSTMENT_ACTIONS = {
  CloseLeg: { value: 'CloseLeg', displayName: 'Close', shortLabel: 'Close' },
  ExecuteLeg: { value: 'ExecuteLeg', displayName: 'Open', shortLabel: 'Open' },
  MoveToCost: { value: 'MoveToCost', displayName: 'Move To Cost', shortLabel: 'MTC' },
  OpenCase: { value: 'OpenCase', displayName: 'Open Case', shortLabel: 'Open Case' },
  CloseCase: { value: 'CloseCase', displayName: 'Close Case', shortLabel: 'Close Case' }
};

export const WAIT_AND_TRADE_TYPES = {
  WAIT_UNTIL_PREMIUM_TO_INCREASE_IN_PERCENTAGE: 'waitUntilPremiumToIncreaseInPercentage',
  WAIT_UNTIL_PREMIUM_TO_DECREASE_IN_PERCENTAGE: 'waitUntilPremiumToDecreaseInPercentage',
};

export const STRIKE_SELECTION_TYPES = {
  EquityBasedStrikeIndex: {
    label: 'Spot Based',
    value: 'EquityBasedStrikeIndex',
    key: 'strikeIndex',
    isPermissionToChoose: true,
    isShow: true,
  },
  FutureBasedStrikeIndex: {
    label: 'Future Based',
    value: 'FutureBasedStrikeIndex',
    key: 'strikeIndex',
    isPermissionToChoose: true,
    isShow: true,
  },
  StrikePrice: {
    label: 'Strike Price',
    value: 'StrikePrice',
    key: 'strikePrice',
    isPermissionToChoose: true,
    isShow: true,
  },
  PremiumBased: {
    label: 'Premium',
    value: 'PremiumBased',
    key: 'premium',
    isPermissionToChoose: true,
    isShow: true,
    comparsions: [
      { label: 'near', value: 'Nearest' },
      { label: 'greater', value: 'GreaterThan' },
      { label: 'lesser', value: 'LesserThan' }
    ]
  },
  IndicatorValueBasedStrikeIndex: {
    label: 'Indicator Based',
    value: 'IndicatorValueBasedStrikeIndex',
    key: 'strikeIndex',
    isPermissionToChoose: _.get(window, 'SA_FEATURE_FLAGS.shouldShowIndicatorBasedStrikeIndex', false)
      || window?.isAdmin || false,
    isShow: isCrypto ? false : true,
  },
  DeltaBased: {
    label: 'Delta',
    value: 'DeltaBased',
    key: 'delta',
    isPermissionToChoose: _.get(window, 'SA_FEATURE_FLAGS.shouldShowDeltaBased', false)
      || window?.isAdmin || false,
    isShow: _.get(window, 'SA_FEATURE_FLAGS.shouldShowDeltaBased', false)
      || window?.isAdmin || false,
    comparsions: [
      { label: 'near', value: 'Nearest' },
      { label: 'greater', value: 'GreaterThan' },
      { label: 'lesser', value: 'LesserThan' }
    ]
  },
};

export const EXPIRY_MONTHLY_DETAILS = {
  '1-monthly': {
    config: { index: 1, cycle: 'monthly' },
    label: 'Current Month',
  },
  '2-monthly': {
    config: { index: 2, cycle: 'monthly' },
    label: 'Next Month',
  },
};

export const EXPIRY_WEEKLY_DETAILS = {
  '1-weekly': {
    config: { index: 1, cycle: 'weekly' },
    label: 'Current Week',
  },
  '2-weekly': {
    config: { index: 2, cycle: 'weekly' },
    label: 'Next Week',
  },
};

export const EXPIRY_DAILY_DETAILS = {
  '1-daily': {
    config: { index: 1, cycle: 'daily' },
    label: 'Current Day',
  },
  '2-daily': {
    config: { index: 2, cycle: 'daily' },
    label: 'Next Day',
  },
};

export const EXPIRY_DETAILS = isCrypto
  ? {
    ...EXPIRY_DAILY_DETAILS,
    ...EXPIRY_WEEKLY_DETAILS,
    ...EXPIRY_MONTHLY_DETAILS,
  }
  : {
    ...EXPIRY_WEEKLY_DETAILS,
    ...EXPIRY_MONTHLY_DETAILS,
  };

export const CHART_PATTERNS = {
  candle: {
    label: 'Candle',
    value: 'candle',
    shouldShow: true,
  },
  heikinashi: {
    label: 'Heikin Ashi',
    value: 'heikinashi',
    shouldShow: true,
  },
  openInterest: {
    label: 'Open Interest',
    value: 'openInterestCandle',
    shouldShow: true,
  },
  volume: {
    label: 'Volume',
    value: 'volumeCandle',
    shouldShow: true,
  },
};

export const QUANT_CONFIG_ORDER_TYPES = {
  market: { label: 'Market', value: 'market' },
  limit: { label: 'Limit', value: 'limit' },
  'sl-l': { label: 'SL Limit', value: 'sl-l' },
};

export const EXTERNAL_SIGNALS_VENDOR_TYPES = {
  TradingView: 'TradingView',
  ChartInk: 'ChartInk',
};

export const INDEX_INSTRUMENTS_ONLY_WEEKLY_EXPIRY = [
  'BFO:SENSEX'
];

export const WEEKLY_EXPIRY_INSTRUMENTS = [
  'NFO:NIFTY',
  ...INDEX_INSTRUMENTS_ONLY_WEEKLY_EXPIRY,
];

export const MONTHLY_ONLY_INDEX = [
  'NFO:BANKNIFTY',
  'NFO:MIDCPNIFTY',
  'BFO:BANKEX',
  'NFO:FINNIFTY',
];

export const ILL_IQUID_INDEX = [
  'NFO:MIDCPNIFTY',
  'BFO:BANKEX',
  'NFO:FINNIFTY',
];

export const MAX_CASES_IN_QUANT = ApplicationDomainUtility.isAdmin ? 25 : 10;

export const INSTAOPTIONS_MODE = {
  live: 'live',
  historical: 'historical',
};

export const INFO_MESSAGE_TYPE = {
  BrokerLogin: 'BrokerLogin',
  BacktestPlan: 'BacktestPlan',
};

export const TEMP_MAIL_LIST = [
  'mailinator',
  'tempmail',
  'yopmail'
];

export const REFERENCE_LIST = {
  case: 'case',
  pipe: 'pipe',
  intent: 'intent',
  adjustment: 'adjustment',
};

export const POINTER_MAP_TO_TITLE = {
  entrySignalPointer: 'Entry When',
  entryIntentPointer: 'Entry Leg',
  exitSignalPointer: 'Exit When',
  adjustmentIntentPointer: 'Adjustment Leg',
  adjustmentSignalPointer: 'Adjust When',
  pipeIntentPointer: 'Indicators Leg',
  pipeSignalPointer: 'Indicators Place',
  quickAdjustmentIntentPointer: 'Quick Adjustments'
}

export const DEFAULT_CRYPTO_INSTRUMENT_INDEX = 0;

const currencySymbols = {
  in: {
    symbol: '₹',
    iconName: 'fa-regular fa-indian-rupee-sign',
    label: 'Amount'
  },
  crypto: {
    symbol: '$',
    label: 'USD'
  },
};

export const currencySymbol = currencySymbols[locale]?.symbol || currencySymbols.in.symbol;

export const currencyLabel = currencySymbols[locale]?.label || currencySymbols.in.label;

export const currencyIconName = currencySymbols[locale]?.iconName || currencySymbols.in.iconName;
